/**
 * @voltxampere/ui — Waveform shared types (Sprint 15)
 *
 * The Waveform Viewer panel runs alongside the schematic editor as
 * a parallel Canvas2D domain (ADR-0023). It plots up to four hard-
 * wired probe channels (CH1-CH4) plus two math channels (M1, M2)
 * that derive from CH expressions. Every consumer in
 * `packages/ui/src/waveform/` shares these types so the channel
 * id, sample shape and trigger contracts stay narrowed across the
 * module boundary.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */
/** Ordered registry — UIs iterate this when they need a stable
 *  layout (toolbar buttons, measurement tile order, theme lookup). */
export const CHANNEL_IDS = ["ch1", "ch2", "ch3", "ch4", "m1", "m2"];
/** Convenience: just the four probe slots in order. */
export const PROBE_CHANNEL_IDS = [
    "ch1",
    "ch2",
    "ch3",
    "ch4",
];
/** Convenience: just the two math slots. */
export const MATH_CHANNEL_IDS = ["m1", "m2"];
export function isProbeChannel(id) {
    return id === "ch1" || id === "ch2" || id === "ch3" || id === "ch4";
}
export function isMathChannel(id) {
    return id === "m1" || id === "m2";
}
/** Defaults: 100 ms timeout matches Rigol/Tektronix scope custom. */
export const DEFAULT_AUTO_TRIGGER_TIMEOUT_S = 0.1;
/** Sample-buffer capacity per channel (Sprint 15 Karar 9). */
export const SAMPLE_BUFFER_CAP = 100_000;
/** Vertical division count — 8 divisions is the analogue scope custom. */
export const V_DIVISION_COUNT = 8;
/** Horizontal division count — 10 is the analogue scope custom. */
export const TIME_DIVISION_COUNT = 10;
//# sourceMappingURL=types.js.map